import { registerFr } from '../i18n/index.js';

registerFr({
  'client': 'cliente',
  'sector not on record': 'secteur non renseigné',
  'Organisation archived.': 'Organisation archivée.',
  'Could not archive the organisation.': "Impossible d'archiver l'organisation.",
  'No organisation addressed': 'Aucune organisation adressée',
  'The link did not name an organisation.': "Le lien ne désigne aucune organisation.",
  'Loading…': 'Chargement…',
  'People': 'Personnes',
  'nobody on record here': 'personne ici au dossier',
  'Day': 'Jour',
  'Ball': 'Balle',
  'no open commitment': 'aucun engagement ouvert',
  'Deals': 'Affaires',
  'face value': 'valeur nominale',
  'no open deal': 'aucune affaire ouverte',
  'Monitors': 'Veilles',
  'the monitors service did not answer': 'le service des veilles n’a pas répondu',
  'counting the monitors…': 'décompte des veilles…',
  'last run': 'dernier passage',
  'never run': 'jamais passée',
  'no monitor watches this organisation': 'aucune veille ne surveille cette organisation',
  'tier': 'niveau',
  'best tier among the people here': 'meilleur niveau parmi les personnes ici',
  // 'Research' seul est le NOM de la quatrième colonne de la fiche personne ; le verbe accentué
  // de l'en-tête est un verbe, d'où sa propre clé de contexte.
  'Research‖verb': 'Rechercher',
  'Queuing…': 'Mise en file…',
  'Send an agent to read the web for this organisation: the raster cells it can cite, the people it meets, the website if the row has none. Everything arrives in Review as a proposal.':
    'Envoyer un agent lire le web sur cette organisation : les cellules de la grille qu’il peut citer, les personnes qu’il croise, le site si la fiche n’en a pas. Tout arrive en Revue comme proposition.',
  'Research {ref} queued. Everything it can cite arrives in Review as a proposal — cells, people, a website — and nothing is written until you hold it.':
    'Recherche {ref} mise en file. Tout ce qu’elle peut citer arrive en Revue comme proposition — cellules, personnes, un site — et rien n’est écrit tant que vous ne l’avez pas retenu.',
  'Could not queue the research run.': 'Impossible de mettre la recherche en file.',
  'Nothing owed and nothing stale here — the record is quiet.': "Rien n'est dû ni en retard ici — le dossier est calme.",
  'People here': 'Personnes ici',
  'Person': 'Personne',
  'Role': 'Rôle',
  'Tier': 'Niveau',
  'Status': 'Statut',
  'Open →': 'Ouvrir →',
  'Nobody here yet': 'Personne ici pour le moment',
  'No person is affiliated with this organisation on the record.': "Aucune personne n'est affiliée à cette organisation au dossier.",
  'Pipeline →': 'Pipeline →',
  'No open deal': 'Aucune affaire ouverte',
  'No opportunity is open for this organisation.': 'Aucune affaire ouverte pour cette organisation.',
  'in stage': 'à cette étape',
  'Open commitments': 'Engagements ouverts',
  'Nothing owed': 'Rien de dû',
  'No commitment is open on either side for this organisation.': "Aucun engagement n'est ouvert, ni d'un côté ni de l'autre, pour cette organisation.",
  'Signals': 'Signaux',
  'a target with a cadence; every run records its outcome': 'une cible et une cadence ; chaque passage consigne son résultat',
  'The monitors could not be read: {error}': 'Les veilles n’ont pas pu être lues : {error}',
  'No monitor watches this organisation. Add one on the Signals page — its website, its careers page, its SHAB publications by UID, news mentions — and its runs and signals appear here.':
    'Aucune veille ne surveille cette organisation. Ajoutez-en une sur la page Signaux — son site, sa page carrières, ses publications FOSC par IDE, ses mentions dans la presse — et ses passages et signaux apparaîtront ici.',
  'Kind': 'Type',
  'Target': 'Cible',
  'Cadence': 'Cadence',
  'Last run': 'Dernier passage',
  'Outcome': 'Issue',
  'website': 'site',
  'careers': 'emplois',
  'news': 'presse',
  'shab': 'FOSC',
  'zefix': 'Zefix',
  'surfe_job': 'Surfe · poste',
  'tender': 'appel d’offres',
  'budget': 'budget',
  'linkedin_manual': 'LinkedIn (manuel)',
  'unchanged': 'inchangé',
  'changed': 'modifié',
  'signal': 'signal',
  'error': 'erreur',
  'paused': 'en pause',
  'failed': 'en échec',
  'Archive this organisation?': 'Archiver cette organisation ?',
  'The organisation stays on the record; it drops out of the active board.': "L'organisation reste au dossier ; elle sort simplement du tableau actif.",

  // round 3 — the market tier in the masthead. The tier words and 'not scored' live in
  // MarketPage.fr.ts and PeoplePage.fr.ts; only the two sentences this page owns are here.
  'fit {f} × timing {ti} × access {a} = {c} — the score below says which rules fired':
    'adéquation {f} × moment {ti} × accès {a} = {c} — la note ci-dessous nomme les règles qui se sont déclenchées',
  'the ICP rules have not scored this organisation':
    'les règles ICP n’ont pas évalué cette organisation',

  // ── round 4 : ce qu’une ligne fusionnée et une filiale disent dans le bandeau ──
  'merged into': 'fusionnée dans',
  'on': 'le',
  'part of': 'fait partie de',
  'this row was archived by a held dedupe proposal; it keeps merged_into for good':
    'cette ligne a été archivée par une décision de doublon retenue ; elle conserve merged_into définitivement',
  'the merge date is not recorded separately; this is the row’s last change':
    'la date de fusion n’est pas enregistrée séparément ; il s’agit de la dernière modification de la ligne',
  'This row was merged into {ref}. Run it on the survivor.':
    'Cette ligne a été fusionnée dans {ref}. Lancez-le sur la ligne conservée.',
  'This row was merged away. Run it on the survivor.':
    'Cette ligne a été fusionnée. Lancez-le sur la ligne conservée.',

  // ── la dernière recherche, les unités, l'arbre ──
  'last research': 'dernière recherche',
  'still running': 'en cours',
  'the last time a research run ended on this organisation':
    'la dernière fois qu’une recherche s’est terminée sur cette organisation',
  '{ref} read the web for this organisation and filed what it could cite':
    '{ref} a lu le web sur cette organisation et a déposé ce qu’elle a pu citer',
  'in the tree': 'dans l’arbre',
  'in {n} units': 'dans {n} unités',
  '{n} direct': '{n} en direct',
  'Units': 'Unités',
  'Unit': 'Unité',
  'departments, sites and programmes under this organisation':
    'départements, sites et programmes rattachés à cette organisation',
  'All people in this tree': 'Toutes les personnes de cet arbre',
  'New unit': 'Nouvelle unité',
  'The tree could not be read: {error}': 'L’arbre n’a pas pu être lu : {error}',
  'No unit sits under this organisation. A unit is a department, a site or a programme with its own name — added here, or proposed by a research run that read it on an organigramme.':
    'Aucune unité n’est rattachée à cette organisation. Une unité est un département, un site ou un programme portant son propre nom — ajouté ici, ou proposé par une recherche qui l’a lu sur un organigramme.',
  'Open deals': 'Affaires ouvertes',
  // declared here so the page reads French without PersonPage's catalogue being loaded
  'Next move': 'Prochain geste',
  'since last touch': 'depuis le dernier contact',
  'not scored': 'non noté',
  'Last contact': 'Dernier contact',
  'no interaction on record': 'aucun échange au dossier',
  'Name': 'Nom',
  '{name} created as a unit of this organisation.': '{name} créée comme unité de cette organisation.',
  'Could not create the unit.': 'L’unité n’a pas pu être créée.',
  'The unit is written as an organisation whose parent is {name}. It appears in the Units zone and in this tree’s people.':
    'L’unité est écrite comme une organisation dont le parent est {name}. Elle apparaît dans la zone Unités et parmi les personnes de cet arbre.',
}, 'OrganisationPage');
